export default __webpack_public_path__ + "static/media/image34.8a62fe0d.png";